<script lang="ts">
	import { getContext, onMount, type Component } from "svelte"
	import { SidebarController } from "./SidebarController.svelte"
	import SidebarMasks from "./Sidebar_Masks.svelte"
	import SidebarMaskCreation from "./Sidebar_MaskCreation.svelte"
	import SidebarMaskEdit from "./Sidebar_MaskEdit.svelte"
	import SidebarRemove from "./Sidebar_Remove.svelte"
	import { ImageModifierController } from "../ImageModifierController.svelte"

	const controller: ImageModifierController = getContext("controller")

	let view = $derived(SidebarController.view)
	const VIEWS: { [key in typeof view]: Component } = {
		default: SidebarMasks,
		"new-mask": SidebarMaskCreation,
		"edit-mask": SidebarMaskEdit,
		remove: SidebarRemove,
	}

	let Comp = $derived(VIEWS[view])

	onMount(async () => {
		if (controller.maskLoadingProimse) await controller.maskLoadingProimse
		if (controller.availableMasks.length === 0) {
			SidebarController.skipToMaskCreation(controller)
		}
	})
</script>

<div id="snapshot-modify-sidebar">
	<Comp />
</div>

<style>
	#snapshot-modify-sidebar {
		width: var(--sidebar-width);
		z-index: 1;
		flex-basis: var(--sidebar-width);
		flex-shrink: 0;
		height: 100%;
		padding: 1rem;
		background-color: var(--color-bg-darker);
		display: flex;
		flex-direction: column;
	}

	:global(.isMobile) #snapshot-modify-sidebar {
		max-height: 50%;
		height: auto;
		flex: 0 0 auto;
	}

	:global(.isMobile) #snapshot-modify-sidebar:has(:global(.expand)) {
		height: 100%;
		max-height: 100%;
		flex-shrink: 0;
	}

	#snapshot-modify-sidebar :global(.info) {
		font-size: var(--h3);
		color: var(--color-text);
		line-height: 1.2em;
	}

	#snapshot-modify-sidebar :global(.info:last-of-type) {
		margin-bottom: 0;
	}

	#snapshot-modify-sidebar :global(.heading) {
		margin-bottom: 0;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		width: 100%;
	}

	#snapshot-modify-sidebar :global(ul),
	#snapshot-modify-sidebar :global(ol) {
		padding-top: 1rem;
	}

	#snapshot-modify-sidebar :global(li) {
		line-height: 1.25em;
	}

	#snapshot-modify-sidebar :global(.heading .link-button) {
		padding: 0;
		color: var(--color-main);
	}

	#snapshot-modify-sidebar :global(.button-container) {
		margin-top: auto;
		margin-bottom: 0;
	}

	#snapshot-modify-sidebar :global(.sidebar-button) {
		width: 100%;
	}

	#snapshot-modify-sidebar :global(ul) {
		margin: 0 0 1rem 0;
		padding-left: 2rem;
		line-height: 1.25rem;
		color: var(--color-text);
	}

	#snapshot-modify-sidebar :global(ul > li) {
		position: relative;
		margin-bottom: 0.75rem;
		padding-left: 0.5rem;
		color: var(--color-text-light);
		list-style: none;
	}

	#snapshot-modify-sidebar :global(ul > li::before) {
		content: "";
		position: absolute;
		left: -1.25rem;
		top: 0;
		bottom: 0;
		margin-top: auto;
		margin-bottom: auto;
		width: 0.5rem;
		height: 0.5rem;
		background-color: var(--color-main);
		border-radius: 50%;
		box-shadow: var(--shadow-small);
	}

	#snapshot-modify-sidebar :global(ul > li:last-child) {
		margin-bottom: 0;
	}
</style>
